import "./order.a5c88637.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPxhr", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", () => $e6fc98820934cce0$export$842dcfa371c6bb83);
$parcel$export(module.exports, "formatPhone", () => $e6fc98820934cce0$export$10c09b2cff9813eb);
function $e6fc98820934cce0$export$842dcfa371c6bb83(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
function $e6fc98820934cce0$export$10c09b2cff9813eb(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return null;
}

});


var $03cFT = parcelRequire("03cFT");

var $ekwLD = parcelRequire("ekwLD");

var $cxph1 = parcelRequire("cxph1");

var $jPxhr = parcelRequire("jPxhr");

var $3w2h1 = parcelRequire("3w2h1");
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    // MARK: - ELEMENTS
    const progressModal = document.getElementById('progressModal');
    const storeNearLabel = document.getElementById("locationsNearZipLabel");
    const locationTableSection = document.getElementById("locationTableSection");
    const editZipcodeButton = document.getElementById("editZipcodeButton");
    const zipcodeModal = document.getElementById("zipcodeModal");
    const modalZipcodeField = document.getElementById("modalZipcodeField");
    const modalZipcodeButton = document.getElementById("modalZipcodeButton");
    var locations = [];
    function setUpView() {
        const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        if (pickupAddress != null) {
            storeNearLabel.innerText = 'STORES NEAR: ' + pickupAddress.postalCode;
            modalZipcodeField.value = pickupAddress.postalCode;
            loadLocations();
        } else zipcodeModal.style.display = 'flex';
    }
    editZipcodeButton.addEventListener('click', async ()=>{
        zipcodeModal.style.display = 'flex';
    });
    // MARK: - LOAD DATA
    async function loadLocations() {
        const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        const geoPoint = new (0, $03cFT.default).GeoPoint({
            latitude: pickupAddress.latitude,
            longitude: pickupAddress.longitude
        });
        progressModal.style.display = 'flex';
        try {
            locations = await (0, $03cFT.default).Cloud.run('loadLocations', {
                'geoPoint': geoPoint
            });
            locationTableSection.style.display = 'block';
            setUpLocationsTable();
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    // MARK: - TABLE FUNCTIONS
    async function setUpLocationsTable() {
        const locationCell = document.querySelector('[locations="cell"]');
        const locationParent = locationCell.parentNode;
        const locationCells = [
            ...document.querySelectorAll('[locations="cell"]')
        ];
        clearCellItems(locationCells);
        for(let i = 0; i < locations.length; i++){
            const newLocationCell = i === 0 ? locationCells[0] : locationCells[0].cloneNode(true);
            const location = locations[i];
            const distanceLabel = newLocationCell.querySelector('[locations="distanceLabel"]');
            const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
            const userPoint = new (0, $03cFT.default).GeoPoint({
                latitude: pickupAddress.latitude,
                longitude: pickupAddress.longitude
            });
            const locationPoint = locations[i].get('location');
            const distance = userPoint.milesTo(locationPoint);
            const distanceSt = distance.toFixed(1) + " miles away";
            distanceLabel.innerText = distanceSt;
            const cityLabel = newLocationCell.querySelector('[locations="cityLabel"]');
            cityLabel.innerText = locations[i].get('city').toUpperCase();
            const addressLabel = newLocationCell.querySelector('[locations="addressLabel"]');
            const address = locations[i].get('address').toUpperCase();
            const state = locations[i].get('state').toUpperCase();
            const zipcode = locations[i].get('zipcode').toUpperCase();
            addressLabel.innerText = address + ', ' + state + ' ' + zipcode;
            var openRows = [];
            const moreInfoButton = newLocationCell.querySelector('[locations="moreInfoButton"]');
            const bottomCell = newLocationCell.querySelector('[locations="bottomCell"]');
            moreInfoButton.addEventListener('click', ()=>{
                if (openRows.includes(i)) {
                    bottomCell.style.display = 'none';
                    let index = openRows.indexOf(i);
                    openRows.splice(index, 1);
                    moreInfoButton.textContent = 'MORE INFO';
                } else {
                    bottomCell.style.display = 'flex';
                    openRows.push(i);
                    moreInfoButton.textContent = 'LESS INFO';
                }
            });
            const chooseButton = newLocationCell.querySelector('[locations="pickupHereButton"]');
            chooseButton.addEventListener('click', async ()=>{
                const location = locations[i];
                const locationObject = {
                    id: location.id,
                    city: location.get('city'),
                    address: location.get('address'),
                    state: location.get('state'),
                    zipcode: '' + location.get('zipcode'),
                    phone: location.get('phonenumber')
                };
                localStorage.setItem('location', JSON.stringify(locationObject));
                sessionStorage.setItem('deliveryBool', 'false');
                progressModal.style.display = 'flex';
                const currentUser = (0, $03cFT.default).User.current();
                if (currentUser != null) {
                    await (0, $03cFT.default).Cloud.run('setUserLocation', {
                        'locationid': location.id
                    });
                    await currentUser.fetch();
                }
                const restaurantGuid = location.get('guid');
                const toastLocation = await (0, $03cFT.default).Cloud.run('getToastLocation', {
                    'restaurantGuid': restaurantGuid
                });
                localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));
                const toastOrderSchedule = await (0, $03cFT.default).Cloud.run('getToastOrderSchedule', {
                    'restaurantGuid': restaurantGuid
                });
                localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));
                const parseMenu = await (0, $03cFT.default).Cloud.run('loadToastMenu', {
                    'restaurantGuid': restaurantGuid
                });
                const toastMenuObject = parseMenu.get('object');
                (0, $3w2h1.storeMenuData)(toastMenuObject);
                const stock = await (0, $03cFT.default).Cloud.run('loadToastStock', {
                    'restaurantGuid': restaurantGuid
                });
                const stocks = stock.get('objects');
                const removeIndexes = (0, $3w2h1.removeUnavailableItems)(stocks);
                if (removeIndexes != null) {
                    if (removeIndexes.length > 0) {
                        removeIndexes.sort(function(a, b) {
                            return b - a;
                        });
                        await (0, $03cFT.default).Cloud.run('removeToastSelections', {
                            'indexes': removeIndexes,
                            'locationid': location.id
                        });
                        alert("Unavailable items have been removed from your box");
                    }
                }
                progressModal.style.display = 'none';
                (0, $cxph1.goToNextPage)('/menu');
            });
            //const image = newLocationCell.querySelector('[locations="image"]');
            //image.src = locations[i].image;
            const phoneButton = newLocationCell.querySelector('[locations="phoneButton"]');
            const phone = locations[i].get('phonenumber');
            phoneButton.innerText = (0, $jPxhr.formatPhone)(phone);
            phoneButton.addEventListener('click', ()=>{
                document.location.href = "tel:" + phone;
            });
            const directionsButton = newLocationCell.querySelector('[locations="directionsButton"]');
            directionsButton.addEventListener('click', ()=>{
                const address = location.get('address');
                const city = location.get('city');
                const state = location.get('state');
                const zipcode = location.get('zipcode');
                const finalAddress = address + ' ' + city + ' ' + state + ' ' + zipcode;
                const addressLink = finalAddress.replaceAll(' ', '+');
                const addressUrl = "https://maps.google.com/?q=Lupo+Pizzeria+" + addressLink;
                window.open(addressUrl, "_blank");
            });
            const locationPageButton = newLocationCell.querySelector('[locations="locationPageButton"]');
            locationPageButton.addEventListener('click', ()=>{
                const city = location.get('city').toLowerCase();
                if (city.includes('fair haven')) (0, $cxph1.goToNextPage)('/fair-haven');
                else if (city.includes('west long branch')) (0, $cxph1.goToNextPage)('/west-long-branch');
            });
            const hoursLabel = newLocationCell.querySelector('[locations="hoursLabel"]');
            // Set hours label
            const restaurantGuid = location.get('guid');
            const toastOrderSchedule = await (0, $03cFT.default).Cloud.run('getToastOrderSchedule', {
                'restaurantGuid': restaurantGuid
            });
            const orderSchedule = toastOrderSchedule.get('object');
            if (orderSchedule != null) {
                const servicePeriods = orderSchedule.servicePeriods;
                const servicePeriod = servicePeriods.find((obj)=>obj.diningOptionBehavior === 'TAKE_OUT');
                if (servicePeriod != null) {
                    const dayPeriods = servicePeriod.dayPeriods;
                    var timeStrings = [];
                    const daysOfWeek = [
                        "SUNDAY",
                        "MONDAY",
                        "TUESDAY",
                        "WEDNESDAY",
                        "THURSDAY",
                        "FRIDAY",
                        "SATURDAY"
                    ];
                    for (const dayOfWeek of daysOfWeek){
                        const period = dayPeriods.find((obj)=>obj.day === dayOfWeek);
                        if (period != null) {
                            const day = period.day;
                            let timeRange = period.timeRanges[0];
                            let startTime = timeRange.start;
                            let endTime = timeRange.end;
                            if (startTime != null) {
                                const startDate = new Date();
                                const startHour = Number(startTime.substring(0, 2));
                                const startMinute = Number(startTime.substring(startTime.length - 2));
                                startDate.setHours(startHour, startMinute, 0, 0);
                                const endDate = new Date();
                                const endHour = Number(endTime.substring(0, 2));
                                const endMinute = Number(endTime.substring(endTime.length - 2));
                                endDate.setHours(endHour, endMinute, 0, 0);
                                const options = {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                };
                                const startString = startDate.toLocaleString('en-US', options);
                                const endString = endDate.toLocaleString('en-US', options);
                                timeStrings.push(day + ' : ' + startString + ' - ' + endString);
                            }
                        } else timeStrings.push(dayOfWeek + ' : CLOSED');
                    }
                    hoursLabel.innerText = timeStrings.join('\n');
                }
            }
            locationParent.appendChild(newLocationCell);
        }
    }
    // MARK: - ZIPCODE MODAL
    $("#zipcodeForm").submit(()=>{
        return false;
    });
    modalZipcodeButton.addEventListener('click', async ()=>{
        const zipcodeText = modalZipcodeField.value;
        if (zipcodeText.length == 5) try {
            const address = await validateAddress(zipcodeText);
            sessionStorage.setItem('pickupAddress', JSON.stringify(address));
            zipcodeModal.style.display = 'none';
            setUpView();
        } catch (e) {
            alert('Invalid address: ' + e.message);
        }
        else alert('zipcode requires 5 digits');
    });
    async function validateAddress(addressText) {
        (0, $ekwLD.default).initialize("prj_live_pk_f7099f165883e6e33410b334bfea0419b2b248f2");
        const addressJson = await (0, $ekwLD.default).forwardGeocode({
            query: addressText
        });
        const address = addressJson.addresses[0];
        return address;
    }
    function clearCellItems(locationCells) {
        locationCells.forEach((cell, index)=>{
            if (index > 0) cell.parentNode.removeChild(cell);
        });
    }
    setUpView();
});


//# sourceMappingURL=locations.57f1e3fa.js.map
